module.exports = __webpack_public_path__ + "static/media/nicolas-leriche.e6781e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/nicolas-leriche.jpg
// module id = 1826
// module chunks = 0